import {
    MAP_GEOFENCES_EDIT_CREATE_GROUP_OPEN_MODAL,
    MAP_GEOFENCES_GET_GEOFENCE_GROUP,
    MAP_GEOFENCES_GET_GEOFENCE_GROUP_RESPONSE,
    MAP_GEOFENCES_EDIT_CREATE_GEOFENCE_GROUP,
    MAP_GEOFENCES_EDIT_CREATE_GEOFENCE_GROUP_RESPONSE,
    CLEAR_REDUX
} from 'Redux/actionTypes';

const INIT_STATE = {
    open: false,
    id: null,
    geofenceGroup: null,
    loadingGeofenceGroup: false,
    response: null,
    loadingResponse: false
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        // Routes
        case MAP_GEOFENCES_EDIT_CREATE_GROUP_OPEN_MODAL:
            return {
                ...state,
                open: action.payload.open,
                id: action.payload.id,
                geofenceGroup: null,
                loadingGeofenceGroup: false,
                response: null,
                loadingResponse: false
            };

        case MAP_GEOFENCES_GET_GEOFENCE_GROUP:
            return {
                ...state,
                geofenceGroup: null,
                loadingGeofenceGroup: true
            };

        case MAP_GEOFENCES_GET_GEOFENCE_GROUP_RESPONSE:
            return {
                ...state,
                geofenceGroup: action.payload.data,
                loadingGeofenceGroup: false
            };

        case MAP_GEOFENCES_EDIT_CREATE_GEOFENCE_GROUP:
            return {
                ...state,
                response: null,
                loadingResponse: true
            };

        case MAP_GEOFENCES_EDIT_CREATE_GEOFENCE_GROUP_RESPONSE:
            return {
                ...state,
                response: action.payload.data,
                loadingResponse: false
            };

        case CLEAR_REDUX:
            return ["", "MAP_GEOFENCES_EDIT_CREATE_GEOFENCE_GROUP"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return { ...state };
    }
}